import i18n from 'simple-react-i18n'
import imgOSM from 'assets/pictures/backgroundsMap/OSM.png'
import imgRoadmap from 'assets/pictures/backgroundsMap/routiere.png'
import imgSatellite from 'assets/pictures/backgroundsMap/satellite.png'
import imgRelief from 'assets/pictures/backgroundsMap/relief.png'
import imgIGN from 'assets/pictures/backgroundsMap/IGN.png'
import OSMSatellite from './layers/OSMSatellite'
import OSMRelief from './layers/OSMRelief'
import OSMRoadMap from './layers/OSMRoadMap'
import IGNMap from './layers/IGNMap'
import WHITE from './layers/WHITE'
import OSM from './layers/OSM'

const BACKGROUNDS = {
    OSM: 'OSM',
    ROADMAP: 'ROADMAP',
    SATELLITE: 'SATELLITE',
    RELIEF: 'RELIEF',
    IGN: 'IGN',
    WHITE: 'WHITE',
}

const getMapBackgrounds = () => {
    return [
        { name: BACKGROUNDS.OSM, label: i18n.bgMapOSM, img: imgOSM },
        { name: BACKGROUNDS.ROADMAP, label: i18n.bgMapRoadMap, img: imgRoadmap },
        { name: BACKGROUNDS.SATELLITE, label: i18n.bgMapSatellite, img: imgSatellite },
        { name: BACKGROUNDS.RELIEF, label: i18n.bgMapRelief, img: imgRelief },
        { name: BACKGROUNDS.IGN, label: i18n.bgMapIGN, img: imgIGN },
        { name: BACKGROUNDS.WHITE, label: i18n.bgMapWhite, img: null },
    ]
}

const getCartographyBackground = (bgName) => {
    switch (bgName) {
        case 'SATELLITE':
            return OSMSatellite()
        case 'RELIEF':
            return OSMRelief()
        case 'ROADMAP':
            return OSMRoadMap()
        case 'IGN':
            return IGNMap()
        case 'WHITE':
            return WHITE()
        default:
            return OSM()
    }
}

export { getMapBackgrounds, BACKGROUNDS, getCartographyBackground }